"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _types = require("./types");

var _SankeyConvert = require("./SankeyConvert");

var _SankeyLayout = require("./SankeyLayout");

var _fileSaver = _interopRequireDefault(require("file-saver"));

var _SankeyUtils = require("./SankeyUtils");

var _Accordion = _interopRequireDefault(require("react-bootstrap/Accordion"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MenuPropTypes = {
  data: _propTypes.default.shape(_types.SankeyDataPropTypes).isRequired,
  set_data: _propTypes.default.func.isRequired,
  open_menu: _propTypes.default.element,
  save_menu: _propTypes.default.element,
  edition_menu: _propTypes.default.element,
  right_menu: _propTypes.default.element,
  settings_edition: _propTypes.default.element,
  settings_edition_tags: _propTypes.default.element,
  node_edition: _propTypes.default.element,
  link_edition: _propTypes.default.element,
  app_name: _propTypes.default.string.isRequired,
  set_show_nav: _propTypes.default.func.isRequired,
  show_nav: _propTypes.default.bool,
  set_nav_item_active: _propTypes.default.func.isRequired,
  nav_item_active: _propTypes.default.string.isRequired,
  set_selected_node: _propTypes.default.func.isRequired,
  selected_node: _propTypes.default.shape(_types.SankeyNodePropTypes).isRequired,
  set_selected_link: _propTypes.default.func.isRequired,
  selected_link: _propTypes.default.shape(_types.SankeyLinkPropTypes).isRequired,
  example_menu: _propTypes.default.element,
  url_prefix: _propTypes.default.string.isRequired,
  getValueIndex: _propTypes.default.func.isRequired,
  radio_selected: _propTypes.default.string.isRequired,
  set_radio_selected: _propTypes.default.func.isRequired,
  agregation_level: _propTypes.default.number.isRequired,
  set_agregation_level: _propTypes.default.func.isRequired
};

var Menu = function Menu(_ref) {
  var data = _ref.data,
      set_data = _ref.set_data,
      open_menu = _ref.open_menu,
      save_menu = _ref.save_menu,
      edition_menu = _ref.edition_menu,
      right_menu = _ref.right_menu,
      settings_edition = _ref.settings_edition,
      settings_edition_tags = _ref.settings_edition_tags,
      node_edition = _ref.node_edition,
      link_edition = _ref.link_edition,
      app_name = _ref.app_name,
      set_show_nav = _ref.set_show_nav,
      show_nav = _ref.show_nav,
      set_nav_item_active = _ref.set_nav_item_active,
      nav_item_active = _ref.nav_item_active,
      set_selected_node = _ref.set_selected_node,
      selected_node = _ref.selected_node,
      set_selected_link = _ref.set_selected_link,
      selected_link = _ref.selected_link,
      example_menu = _ref.example_menu,
      url_prefix = _ref.url_prefix,
      getValueIndex = _ref.getValueIndex,
      radio_selected = _ref.radio_selected,
      set_radio_selected = _ref.set_radio_selected,
      agregation_level = _ref.agregation_level,
      set_agregation_level = _ref.set_agregation_level;
  var set_show_link = (0, _react.useState)(true)[1];
  var display_nodes = data.nodes;
  var display_links = data.links;
  var nb_agregation_level = 0;
  Object.values(data.nodes).forEach(function (n) {
    if (!n.dimensions) {
      return;
    }

    Object.entries(n.dimensions).forEach(function (dim) {
      if (!dim[1].level) {
        return;
      }

      nb_agregation_level = dim[1].level > nb_agregation_level ? dim[1].level : nb_agregation_level;
    });
  });
  var value_index = getValueIndex(data);

  var add_new_node = function add_new_node() {
    var nodes = data.nodes;
    var node = (0, _SankeyUtils.default_node)(); // en remplacement de node_idx
    //data.node_idx = data.node_idx + 1
    // Méthode pour incrementer idNode

    var listId = [];
    Object.keys(data.nodes).forEach(function (elt) {
      return listId.push(Number(elt.replace('node', '')));
    });
    var idNode = listId.length > 0 ? Math.max.apply(Math, listId) + 1 : 0;
    node.idNode = 'node' + idNode;
    node.name = node.idNode;
    node.x = Object.keys(nodes).length * 50;
    nodes[node.idNode] = node;
    set_selected_node(node);
    set_data((0, _objectSpread2.default)({}, data));
  };

  var _load_json = (0, _react.useRef)(null);

  var _load_simple_excel = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 1),
      processing = _useState2[0];

  var clickSaveDiagram = function clickSaveDiagram() {
    var data_to_save = (0, _objectSpread2.default)({}, data);
    var str_data = JSON.stringify(data_to_save, null, 3);
    var blob = new Blob([str_data], {
      type: 'text/plain;charset=utf-8'
    });

    _fileSaver.default.saveAs(blob, 'sankey_diagram.json');
  };

  var clickSaveSVG = function clickSaveSVG() {
    var svg = window.d3.select('svg');
    svg.selectAll('.tooltip').remove();
    svg.selectAll('text[visibility=hidden]').remove();
    var html = svg.attr('title', 'test2').attr('version', 1.1).attr('xmlns', 'http://www.w3.org/2000/svg').node().parentNode.innerHTML;
    var blob = new Blob([html], {
      type: 'image/svg+xml'
    });

    _fileSaver.default.saveAs(blob, 'sankey_diagram.svg');
  };

  var clickSavePDF = function clickSavePDF() {
    var svg = window.d3.select('svg');
    svg.selectAll('.tooltip').remove();
    svg.selectAll('text[visibility=hidden]').remove();
    var html = svg.attr('title', 'test2').attr('version', 1.1).attr('xmlns', 'http://www.w3.org/2000/svg').node().parentNode.innerHTML;
    var blob = new Blob([html], {
      type: 'image/svg+xml'
    });
    var data = new FormData();
    data.append('svg', blob);
    var path = window.location.href;
    var url = path + 'sankey/save_pdf';
    var fetchData = {
      method: 'POST',
      body: data
    };

    var showFile = function showFile(blob) {
      var newBlob = new Blob([blob], {
        type: 'application/pdf'
      });

      _fileSaver.default.saveAs(newBlob, 'sankey_diagram.pdf');
    };

    var cleanFile = function cleanFile() {
      var fetchData = {
        method: 'POST'
      };
      url = path + 'sankey/clean_pdf';
      fetch(url, fetchData);
    };

    fetch(url, fetchData).then(function (r) {
      return r.blob();
    }).then(showFile).then(cleanFile);
  };

  var uploadJSON = function uploadJSON() {
    if (_load_json.current) {
      _load_json.current.name = '';

      _load_json.current.click();
    }
  };

  var uploadJSONImpl = function uploadJSONImpl(evt) {
    var files = evt.target.files;
    var reader = new FileReader();

    reader.onload = function () {
      return function (e) {
        var result = String(e.target.result);
        result = result.split('<br>').join('\\\\n');
        var new_data = JSON.parse(result);
        data.tags_catalog = {};
        Object.assign(data, new_data);
        (0, _SankeyConvert.convert_data)(data);
        set_data((0, _objectSpread2.default)({}, data));
      };
    }();

    reader.readAsText(files[0]);
  };

  var reinitialization = function reinitialization() {
    var data = (0, _SankeyUtils.default_sankey_data)();
    set_data((0, _objectSpread2.default)({}, data));
  };

  var setShow = function setShow(t) {
    set_show_nav(t);
  };

  var handleClose = function handleClose() {
    return setShow(true);
  };

  var toggleShow = function toggleShow() {
    setShow(!show_nav);
  };

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      checked = _useState4[0],
      setChecked = _useState4[1];

  var add_new_link = function add_new_link() {
    var nodes = data.nodes,
        links = data.links;

    if (Object.keys(nodes).length < 2) {
      return;
    }

    var link = (0, _SankeyUtils.default_link)();
    link.idLink = 'link' + Object.keys(links).length;
    links[link.idLink] = link;
    var node_keys = Object.keys(nodes);
    link.idSource = nodes[node_keys[0]].idNode;
    link.idTarget = nodes[node_keys[1]].idNode;
    nodes[node_keys[0]].outputLinksId.push(link.idLink);
    nodes[node_keys[1]].inputLinksId.push(link.idLink);
    set_selected_link(link);
    set_data((0, _objectSpread2.default)({}, data));
    set_show_link(true);
  };

  var node = selected_node;

  if (node === undefined) {
    node = (0, _SankeyUtils.default_node)();
  }

  var source_change = function source_change(changeEvent) {
    var link = selected_link;
    console.log('========1============='); //Causait un problème d'acumulation de la valeur de des differents link sur des noeuds non associé
    // const previous_node = nodes.filter(n => n.name === link.target_name)[0]

    var previous_node = data.nodes[link.idSource];
    previous_node.outputLinksId.splice(previous_node.outputLinksId.indexOf(selected_link.idLink), 1);
    var source_node = data.nodes[changeEvent.target.value];
    link.idSource = source_node.idNode;
    source_node.outputLinksId.push(selected_link.idLink);
    set_data((0, _objectSpread2.default)({}, data));
  };

  var addDropSource = function addDropSource() {
    if (Object.keys(data.nodes).length >= 2 && Object.keys(data.links).length != 0) {
      return Object.values(data.nodes).map(function (n, i) {
        return /*#__PURE__*/_react.default.createElement("option", {
          key: i,
          value: n.idNode,
          selected: selected_link.idSource === n.idNode
        }, n.name);
      });
    }
  };

  var addDropCible = function addDropCible() {
    if (Object.keys(data.nodes).length >= 2 && Object.keys(data.links).length != 0) {
      return Object.values(data.nodes).map(function (n, i) {
        return /*#__PURE__*/_react.default.createElement("option", {
          key: i,
          value: n.idNode,
          selected: selected_link.idTarget === n.idNode
        }, n.name);
      });
    }
  };

  var target_change = function target_change(changeEvent) {
    var nodes = data.nodes;
    var link = selected_link;
    var previous_node = nodes[link.idTarget];
    previous_node.inputLinksId.splice(previous_node.inputLinksId.indexOf(selected_link.idLink), 1);
    var target_node = nodes[changeEvent.target.value];
    link.idTarget = target_node.idNode;
    target_node.inputLinksId.push(selected_link.idLink);
    set_data((0, _objectSpread2.default)({}, data));
  };

  var addLabelId = function addLabelId() {
    if (Object.keys(display_nodes).length != 0) {
      return selected_node.idNode;
    }
  };

  var link = selected_link;
  var props = {
    scroll: true,
    backdrop: false
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Navbar, {
    className: "bg-light",
    fixed: "top",
    expand: "xl"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Navbar.Brand, {
    href: "#"
  }, app_name), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Nav, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown, {
    title: "Fichiers",
    id: "files"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown, {
    id: "ouvrir",
    title: "Ouvrir"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    onClick: uploadJSON
  }, "JSON"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "file",
    ref: _load_json,
    style: {
      display: 'none'
    },
    onChange: uploadJSONImpl
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    onClick: function onClick() {
      if (_load_simple_excel && _load_simple_excel.current) {
        _load_simple_excel.current.name = '';

        _load_simple_excel.current.click();
      }
    }
  }, "Excel simple"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    style: {
      display: 'none'
    },
    ref: _load_simple_excel,
    type: "file",
    onChange: function onChange(evt) {
      var files = evt.target.files;
      var form_data = new FormData();
      form_data.append('file', files ? files[0] : '');
      var fetchData = {
        method: 'POST',
        body: form_data
      };

      var callback = function callback(server_data) {
        var error = server_data['error'];

        if (error && error.length != 0) {
          alert(error);
          return;
        }

        Object.assign(data, server_data);
        (0, _SankeyConvert.convert_data)(data);
        data.node_idx = Object.keys(data.nodes).length;
        data.link_idx = Object.keys(data.links).length;
        (0, _SankeyLayout.compute_auto_sankey)(data, 200);
        set_data((0, _objectSpread2.default)({}, data));
      };

      var root = window.location.href;

      if (root.includes('sankey-diagrams')) {
        root = root.replace('sankey-diagrams/', '');
      }

      var url = root + url_prefix + 'sankey/upload_simple_excel';
      fetch(url, fetchData).then(function (response) {
        response.text().then(function (text) {
          // try {
          var json_data = JSON.parse(text);
          callback(json_data); // } catch(err) {
          //   alert(err)
          // }
        });
      });
    }
  }), open_menu), /*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown, {
    id: "enregistrer",
    title: "Enregistrer"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    onClick: clickSaveDiagram
  }, "JSON"), save_menu), /*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown, {
    id: "exporter",
    title: "Exporter"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    onClick: clickSaveSVG
  }, "Exporter SVG"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    onClick: clickSavePDF
  }, "Exporter PDF"))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown, {
    id: "edition",
    title: "Edition"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    onClick: reinitialization
  }, "R\xE9initialiser"), edition_menu), /*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown, {
    title: "Aide",
    id: "help"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    eventKey: "documentation",
    href: "../../doc/user_su-model-sankey.html",
    target: "_blank"
  }, "Documentation"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown, {
    title: "Exemples",
    id: "exemples"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    onClick: function onClick() {
      return (0, _SankeyUtils.uploadExemple)('pommes_poires.xlsx', url_prefix, data, set_data, function (server_data) {
        (0, _SankeyLayout.compute_auto_sankey)(server_data, server_data.h_space ? server_data.h_space : 200);
      });
    }
  }, "Pommes Poires Simple"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    onClick: function onClick() {
      return (0, _SankeyUtils.uploadExemple)('sankeys_territoire_.csv', url_prefix, data, set_data, function (server_data) {
        (0, _SankeyLayout.compute_default_input_outputLinksId)(server_data.nodes, server_data.links);
        (0, _SankeyLayout.updateLayout)(server_data, server_data.layout);
        Object.values(server_data.nodes).forEach(function (n) {
          (0, _SankeyLayout.reorganize_node_inputLinksId)(n, data.nodes, data.links);
          (0, _SankeyLayout.reorganize_node_outputLinksId)(n, data.nodes, data.links);
        });
        delete data.layout;
      });
    }
  }, "Energie"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    onClick: function onClick() {
      return (0, _SankeyUtils.uploadExemple)('foret_bois_savoie.json', url_prefix, data, set_data, function () {
        return 0;
      });
    }
  }, "For\xEAt Bois Savoie"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    onClick: function onClick() {
      return (0, _SankeyUtils.uploadExemple)('foret_bois_grand_est.json', url_prefix, data, set_data, function () {
        return 0;
      });
    }
  }, "For\xEAt Bois Grand Est"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    onClick: function onClick() {
      return (0, _SankeyUtils.uploadExemple)('viande_nationale.json', url_prefix, data, set_data, function () {
        return 0;
      });
    }
  }, "Viande"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    onClick: function onClick() {
      return (0, _SankeyUtils.uploadExemple)('filiere_lait.json', url_prefix, data, set_data, function () {
        return 0;
      });
    }
  }, "Lait"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown.Divider, null), example_menu)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.ButtonGroup, {
    className: "mb-2",
    style: {
      'width': '480px'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.ToggleButton, {
    id: "toggle-check",
    type: "checkbox",
    variant: "outline-primary",
    checked: checked,
    onChange: function onChange(e) {
      setChecked(e.currentTarget.checked);
    },
    onClick: toggleShow,
    value: "1"
  }, "Configuration Sankey")), right_menu))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Offcanvas, Object.assign({
    show: show_nav,
    placement: "end",
    onHide: handleClose
  }, props, {
    style: {
      'width': '540px',
      'margin-top': '70px'
    }
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Offcanvas.Body, {
    style: {
      'padding': '0px'
    }
  }, /*#__PURE__*/_react.default.createElement(_Accordion.default, {
    activeKey: nav_item_active
  }, /*#__PURE__*/_react.default.createElement(_Accordion.default.Item, {
    eventKey: "0",
    onClick: function onClick(evt) {
      if (evt.target.className === 'accordion-button' && nav_item_active === '0') {
        set_nav_item_active('');
      } else {
        set_nav_item_active('0');
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_Accordion.default.Header, null, "Shortcut"), /*#__PURE__*/_react.default.createElement(_Accordion.default.Body, null, /*#__PURE__*/_react.default.createElement("p", null, "Fonctionnement des clics :"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "CTRL + Click (noeuds) :"), " Selectionne le noeuds click dans l onglet Noeuds du menu"))), /*#__PURE__*/_react.default.createElement(_Accordion.default.Item, {
    eventKey: "1",
    onClick: function onClick(evt) {
      if (evt.target.className === 'accordion-button' && nav_item_active === '1') {
        set_nav_item_active('');
      } else {
        set_nav_item_active('1');
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_Accordion.default.Header, null, "Param\xEAtres g\xE9n\xE9raux"), /*#__PURE__*/_react.default.createElement(_Accordion.default.Body, null, settings_edition)), /*#__PURE__*/_react.default.createElement(_Accordion.default.Item, {
    eventKey: "2",
    onClick: function onClick(evt) {
      if (evt.target.className === 'accordion-button' && nav_item_active === '2') {
        set_nav_item_active('');
      } else {
        set_nav_item_active('2');
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_Accordion.default.Header, null, "Noeuds"), /*#__PURE__*/_react.default.createElement(_Accordion.default.Body, null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 1
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    style: {
      'marginBottom': '3px'
    },
    onClick: add_new_node
  }, "+")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 10
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Select, {
    id: "selectionNode",
    onChange: function onChange(evt) {
      set_selected_node(display_nodes[evt.target.value]);
    }
  }, " ", /*#__PURE__*/_react.default.createElement("option", {
    value: 'default',
    disabled: selected_node.idNode === 'default' ? false : true
  }, " Choisissez noeud"), Object.values(data.nodes).map(function (n, i) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: i,
      value: n.idNode,
      selected: selected_node.idNode != 'default' && n.idNode === selected_node.idNode ? true : false
    }, n.name);
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 1
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    variant: "danger",
    style: {
      'marginBottom': '3px'
    },
    onClick: function onClick() {
      (0, _SankeyUtils.delete_node)(data, selected_node);
      set_selected_node((0, _SankeyUtils.default_node)());
      set_data((0, _objectSpread2.default)({}, data));
    }
  }, "-"))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 2
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Nom")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 7
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl, {
    value: selected_node.name,
    onChange: function onChange(evt) {
      selected_node.name = evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 3
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "(id : ", addLabelId(), ")")))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 2
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "H\xE9ritage")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 2
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    value: "general",
    type: "radio",
    label: "G\xE9n\xE9ral",
    checked: node.node_parameter === 'general',
    onChange: function onChange(evt) {
      console.log(evt.target.value);
      node.node_parameter = evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 3
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    value: "groupTag",
    type: "radio",
    label: "Groupe Tag",
    checked: node.node_parameter === 'groupTag',
    onChange: function onChange(evt) {
      node.node_parameter = evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 2
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    value: "local",
    type: "radio",
    label: "local",
    checked: node.node_parameter === 'local',
    onChange: function onChange(evt) {
      console.log(evt.target.value);
      node.node_parameter = evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })))), /*#__PURE__*/_react.default.createElement("br", null), node_edition)), /*#__PURE__*/_react.default.createElement(_Accordion.default.Item, {
    eventKey: "3",
    onClick: function onClick(evt) {
      if (evt.target.className === 'accordion-button' && nav_item_active === '3') {
        set_nav_item_active('');
      } else {
        set_nav_item_active('3');
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_Accordion.default.Header, null, "Links"), /*#__PURE__*/_react.default.createElement(_Accordion.default.Body, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 1
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    variant: "success",
    onClick: function onClick() {
      add_new_link();
      set_data((0, _objectSpread2.default)({}, data));
    }
  }, "+")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 10
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Select, {
    id: "selectionLink",
    onChange: function onChange(evt) {
      var newLink = Object.values(display_links).filter(function (f) {
        return f.idLink == evt.target.value;
      })[0];
      set_selected_link(newLink);
      set_data((0, _objectSpread2.default)({}, data));
    }
  }, Object.values(data.links).map(function (l, i) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: i,
      value: l.idLink,
      selected: l.idLink == selected_link.idLink
    }, display_nodes[l.idSource].name + ' -> ' + display_nodes[l.idTarget].name);
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 1
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    size: "sm",
    variant: "danger",
    onClick: function onClick() {
      (0, _SankeyUtils.delete_link)(data, selected_link);
      set_selected_link((0, _SankeyUtils.default_link)());
      set_data((0, _objectSpread2.default)({}, data));
    }
  }, "-"))), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Source")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Select, {
    onChange: source_change
  }, addDropSource()))), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Cible")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Select, {
    onChange: target_change
  }, addDropCible()))), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Valeur")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    value: link.value[value_index],
    onChange: function onChange(evt) {
      console.log(selected_link);
      console.log(selected_link.value[value_index]);
      selected_link.value[value_index] = +evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))), link_edition)), /*#__PURE__*/_react.default.createElement(_Accordion.default.Item, {
    eventKey: "4",
    onClick: function onClick(evt) {
      if (evt.target.className === 'accordion-button' && nav_item_active === '4') {
        set_nav_item_active('');
      } else {
        set_nav_item_active('4');
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_Accordion.default.Header, null, "Tags"), /*#__PURE__*/_react.default.createElement(_Accordion.default.Body, null, settings_edition_tags)), /*#__PURE__*/_react.default.createElement(_Accordion.default.Item, {
    eventKey: "5",
    onClick: function onClick(evt) {
      if (evt.target.className === 'accordion-button' && nav_item_active === '5') {
        set_nav_item_active('');
      } else {
        set_nav_item_active('5');
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_Accordion.default.Header, null, "Niveaux agr\xE9gation"), /*#__PURE__*/_react.default.createElement(_Accordion.default.Body, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Niveau agr\xE9gation")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Select, {
    id: "selectionNode",
    onChange: function onChange(evt) {
      if (evt.target.value === '') {
        return;
      }

      for (var level = 1; level <= +evt.target.value + 1; level++) {
        (0, _SankeyUtils.set_nodes_level)(display_nodes, level);
      }

      set_agregation_level(+evt.target.value);
      set_data((0, _objectSpread2.default)({}, data));
    }
  }, (0, _toConsumableArray2.default)(Array(nb_agregation_level).keys()).map(function (level) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: level,
      value: level,
      selected: level === agregation_level
    }, 'Niveau ' + (level + 1));
  })))))), /*#__PURE__*/_react.default.createElement(_Accordion.default.Item, {
    eventKey: "6",
    onClick: function onClick(evt) {
      if (evt.target.className === 'accordion-button' && nav_item_active === '6') {
        set_nav_item_active('');
      } else {
        set_nav_item_active('6');
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_Accordion.default.Header, null, "Aide"), /*#__PURE__*/_react.default.createElement(_Accordion.default.Body, null))))), processing ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Dialog, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    className: "btn btn-sm btn-warning col-md-12"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "glyphicon glyphicon-refresh glyphicon-refresh-animate"
  }), " Processing...")) : /*#__PURE__*/_react.default.createElement("div", null));
};

var _default = Menu;
exports.default = _default;